(function ($) {
  // ページロード中にクリックしたpost IDを管理（プライベートブラウザ対策）
  var clickedThisLoad = {};

  $(function () {
    // クッキーに記録済みの投稿はボタンを無効化
    $('.js-like-btn').each(function () {
      var postId = $(this).data('post-id');
      if (getCookie('liked_' + postId)) {
        disableLikeBtn($(this));
      }
    });

    // いいねボタン クリックイベント
    $(document).on('click', '.js-like-btn', function () {
      var $btn = $(this);
      var postId = $btn.data('post-id');

      // ページロード中 or クッキーで既にクリック済み or リクエスト送信中なら処理しない
      if (clickedThisLoad[postId] || getCookie('liked_' + postId) || $btn.data('in-flight')) {
        return;
      }

      // リクエスト送信中フラグ
      $btn.data('in-flight', true);

      // ページロード中のクリック済みとしてマーク
      clickedThisLoad[postId] = true;

      // 楽観的UIとしてすぐ無効化
      disableLikeBtn($btn);

      // AJAXリクエスト
      $.ajax({
        url: likeAjax.ajaxUrl,
        type: 'POST',
        data: {
          action: 'increment_like_count',
          post_id: postId,
          nonce: likeAjax.nonce,
        },
        success: function (res) {
          if (res.success) {
            $btn.find('.news-list-parts__count').text(res.data.count);
            setCookie('liked_' + postId, '1', 365);
          } else {
            // 失敗時は元に戻す
            enableLikeBtn($btn);
            $btn.data('in-flight', false);
            delete clickedThisLoad[postId];
          }
        },
        error: function () {
          // エラー時は元に戻す
          enableLikeBtn($btn);
          $btn.data('in-flight', false);
          delete clickedThisLoad[postId];
        },
      });
    });
  });

  function disableLikeBtn($btn) {
    $btn.addClass('is-liked');
  }

  function enableLikeBtn($btn) {
    $btn.removeClass('is-liked');
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }
})(jQuery);
